import React from 'react';
import { Grid, Box, IconButton, useTheme, Stack } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import AnnouncementsTab from '../../features/Search/components/AnnouncementsTab';
import ProfileActions from '../../features/Search/components/ProfileActions';
import ChatTabs from '../../features/Search/components/ChatTabs';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentUser, setLayout } from '../../features/Auth/authSlice';
import SwipeEdge from '../../common/SwipeEdge';
import { ViewportSettings } from '../../pages';
import { toggleSwipe } from '../../features/Search/searchSlice';
import { Settings } from '@mui/icons-material';
import Profile from '../../features/Profile/components/Profile';
import ProfileNavbar from '../../features/Profile/components/ProfileNavbar';
import NavBar from './NavBar';
import useDeviceDetect from '../../hooks/useDeviceDetect';
import { useGetEmployeeProfileQuery } from '../../features/Auth/authApiSlice';
import ProfileImageDialog from '../../utils/ProfileImageDialog';

const MobileLayout = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const isLeftOpen = pathname.split('/').length < 3;
  const currentPage = pathname.split('/')[2];
  const isLevel1 = currentPage == 'announcement' && pathname.split('/').length == 4;
  const isReimbursement = pathname.split('/')[4] == 'reimbursement';
  // const isReimbursement = false;
  const currentView = isLeftOpen ? 'left' : 'right';
  const isMobile = useDeviceDetect();
  const user = useSelector(selectCurrentUser);
  // const { data: userProfile } = useGetEmployeeProfileQuery(user?.empCode);
  const handleNavClick = (nav) => {
    navigate(`${nav.path}`);
  };
  const handleAnnouncementClick = (nav) => {
    if (nav.path == 'admin') {
      dispatch(setLayout('admin'));
      navigate('/admin');
      return;
    }
    navigate(`announcement/${nav.path}`);
  };

  const handleProfileClick = (empCode) => {
    navigate(`aboutme/${empCode}`);
    console.log('ABOUTME');
  };
  const openConfig = () => {
    dispatch(toggleSwipe({ value: true }));
    window['ReactNativeWebView'] &&
      window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'swipe', value: true }));
  };
  return (
    <Grid
      xs={12}
      lg={2.5}
      item
      sx={{
        width: '100vw',
        maxWidth: '100%',
        overflowX: 'hidden',
        borderRight: 0,
        borderColor: 'divider',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        p: 1.5,
        pb: 0,
        gap: 1,
        margin: 0,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        WebkitOverflowScrolling: 'touch',
      }}
      container
    >
      {/* profile actions */}
      {/* {currentPage == 'chats' ? (
        <ProfileNavbar />
      ) : (
        <ProfileActions
          handleNavClick={handleNavClick}
          handleProfileClick={handleProfileClick}
          handleAnnouncementClick={handleAnnouncementClick}
        />
      )} */}
      {isLevel1 ? (
        <ProfileActions
          handleNavClick={handleNavClick}
          handleProfileClick={handleProfileClick}
          handleAnnouncementClick={handleAnnouncementClick}
        />
      ) : isReimbursement ? (
        <></>
      ) : (
        <div>
          <NavBar />
        </div>
      )}
      {/* profile list & team section */}
      <Stack
        sx={{
          height: `calc(100vh - ${isLevel1 ? '135px' : isReimbursement ? '0px' : '90px'})`,
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
        }}
      >
        <Outlet />
      </Stack>
      {/* announcements */}
      {/* <AnnouncementsTab handleClick={handleAnnouncementClick} /> */}
      {/* <IconButton
        onClick={() => openConfig()}
        sx={{
          display: 'flex',
          position: 'absolute',
          bottom: 'calc(10vh)',
          left: 'calc(2vw)',
          borderRadius: '50%',
          border: 1,
          borderColor: 'divider',
          background: 'white',
          cursor: 'pointer',
          boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 3px, rgba(0, 0, 0, 0.20) 0px 1px 3px',
          p: 1,
        }}
      >
        <Settings sx={{ color: 'black' }} fontSize="small" />
      </IconButton> */}
      {/* {currentView === 'left' ? (
        <SwipeEdge
          height="70vh"
          drawerBleeding={0}
          title="Viewport"
          content={<ViewportSettings />}
        />
      ) : null} */}
      {/* {userProfile && <ProfileImageDialog open={userProfile?.employeePhotoPath == null} />} */}
    </Grid>
  );
};

export default MobileLayout;
